<div class="content">
  <div class="column">
    <!-- Devices Table -->
    <lin-billing-table [caption]="'BILLING.CAPTIONS.DEVICES' | translate" [tableHeader]="true" [scrollable]="true">
      <tr>
        <td>{{ 'BILLING.STATUSES.active' | translate }}</td>
        <td>{{ billingQuantities.activeTrackers }}</td>
        <td class="expand-trigger" (click)="activeDevicesExpanded = !activeDevicesExpanded">
          <span>{{ (activeDevicesExpanded ? 'BILLING.SHOW_LESS' : 'BILLING.SHOW_MORE') | translate }}</span>
          <mat-icon>{{ activeDevicesExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </td>
        <td>{{ activeTrackersTotal | platformCurrency }}</td>
      </tr>
      @if (activeDevicesExpanded) {
      <tr billingTableRowExpanded [name]="'activeVehicleTrackers'" [notEditable]="!editable"></tr>
      <tr billingTableRowExpanded [name]="'activePersonalTrackers'" [notEditable]="!editable"></tr>
      <tr billingTableRowExpanded [name]="'activeAssetTrackers'" [notEditable]="!editable"></tr>
      <tr billingTableRowExpanded [name]="'activeSatelliteTrackers'" [notEditable]="!editable"></tr>
      @if (editable) {
      <tr class="button-row">
        <td></td>
        <td></td>
        <td>
          <lin-form-submit-button [isLoading]="trackersLoading" (click)="saveTrackers()">
            {{ 'BUTTONS.SAVE' | translate }}
          </lin-form-submit-button>
        </td>
        <td></td>
      </tr>
      } @else {
      <tr class="last-expanded-row"></tr>
      } }
      <tr billingTableRow [status]="'deactivated'" [quantity]="billingQuantities.deactivatedTrackers"></tr>
    </lin-billing-table>

    <!-- Vehicles Table -->
    <lin-billing-table [caption]="'BILLING.CAPTIONS.VEHICLES' | translate" [tableHeader]="true" [scrollable]="true">
      <tr billingTableRow [status]="'active'" [name]="'activeVehicles'"></tr>
      <tr billingTableRow [status]="'virtual'" [name]="'virtualVehicles'" [isEditable]="editable"></tr>
      <tr billingTableRow [status]="'deleted'" [name]="'deletedVehicles'"></tr>
      <tr billingTableRow [status]="'archived'" [name]="'archivedVehicles'" [isEditable]="editable"></tr>
    </lin-billing-table>
  </div>

  <div class="column">
    <!-- Sensors Table -->
    <lin-billing-table [caption]="'BILLING.CAPTIONS.SENSORS' | translate" [tableHeader]="true" [scrollable]="true">
      <tr billingTableRow [status]="'active'" [name]="'activeSensors'" [isEditable]="editable"></tr>
      <tr billingTableRow [status]="'deleted'" [name]="'deletedSensors'"></tr>
      <tr billingTableRow [status]="'archived'" [name]="'archivedSensors'" [isEditable]="editable"></tr>
    </lin-billing-table>

    <!-- Addon Modules Table -->
    <!-- <lin-billing-table [caption]="'BILLING.CAPTIONS.ADDON_MODULES' | translate" [tableHeader]="true" [scrollable]="true">
      <tr billingTableRow [status]="'prism_ftc'" [name]="'prismFTC'" [isEditable]="editable"></tr>
    </lin-billing-table> -->

    <lin-billing-table [caption]="'BILLING.CAPTIONS.TOTAL' | translate: { value: totalPrice | platformCurrency }" [notes]="true">
      <div notes>{{ 'BILLING.EXCLUDING_TAX' | translate }}</div>
    </lin-billing-table>
  </div>
</div>
